import React from 'react';

import classNames from 'classnames';

import { NumberTuple } from '../types';

import styles from './Diagram.module.scss';

interface PriceDiagramProps {
    list: number[];
    selectedIndexes?: NumberTuple;
    customClass?: {
        Diagram?: string;
    };
    firstBarActive?: boolean;
}

const getBarHeight = (heightBar: number): number =>
    heightBar > 15 ? heightBar : heightBar !== 0 ? 15 : 0;

const Diagram = ({
    list,
    selectedIndexes = [0, 0],
    customClass,
    firstBarActive = false,
}: PriceDiagramProps) => {
    const maxCountInRanges = Math.max(...list);
    const hasMaxCount = maxCountInRanges > 0;
    const [startIndex, endIndex] = selectedIndexes;

    return (
        <div className={classNames(styles.Diagram, customClass?.Diagram)}>
            {list.map((value, index) => {
                const heightBar = hasMaxCount
                    ? (value / maxCountInRanges) * 100
                    : 0;

                return (
                    <span
                        key={index}
                        className={classNames(styles.Bar, {
                            [styles.InactiveBar]:
                                index < startIndex ||
                                index > endIndex ||
                                !firstBarActive,
                        })}
                        style={
                            {
                                '--height': `${getBarHeight(heightBar)}%`,
                            } as React.CSSProperties
                        }
                    />
                );
            })}
        </div>
    );
};

export default Diagram;
